/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-destructuring */
/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Vocabulary } from "../../Utils/Vocabulary";
import {
  InventoryModel,
  ProductModel,
  StockTransferProductModel,
} from "../../Utils/Models";
import { getData } from "../../Services/getData";
import { urlEnum } from "../../Utils/UrlEnum";

type ProductsAutocompleteProps = {
  parentProduct: any;
  inventory: InventoryModel | null;
  handleChangeProductInParent: (event: any, value: any) => void;
  variant?: "standard" | "outlined" | "filled";
  disabled?: boolean;
  styles?: any;
  invoiceProducts?: StockTransferProductModel[];
  setShouldReset?: React.Dispatch<React.SetStateAction<boolean>>;
};
export default function ProductsAutocomplete(props: ProductsAutocompleteProps) {
  const {
    parentProduct,
    inventory,
    handleChangeProductInParent,
    variant,
    disabled,
    styles,
    invoiceProducts,
  } = props;
  const [products, setProducts] = useState<ProductModel[]>([]);
  const [product, setProduct] = useState<string>("");

  useEffect(() => {
    // Fetch initial products
    searchProducts("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inventory]);

  /**
   * Search products from API
   */
  async function searchProducts(search: string) {
    try {
      const inventoryId = inventory?._id || "null";
      const response = await getData(
        `${urlEnum.products}/search/${search || "null"}/${inventoryId}`
      );
      if (response?.data?.result) {
        setProducts(response.data.result);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  }

  function setProductsFromInvoice() {
    if (invoiceProducts) {
      setProducts((prevProducts) => {
        const newProducts: ProductModel[] = [...prevProducts];

        invoiceProducts.forEach((invoiceProduct) => {
          const product = invoiceProduct?.product;

          if (
            product && // Ensure product is not null or undefined
            !prevProducts.some((p) => p._id === product._id)
          ) {
            newProducts.push(product);
          }
        });
        return newProducts;
      });
    }
  }

  useEffect(() => {
    setProductsFromInvoice();
  }, [invoiceProducts]);


  /**
   *
   * @param event
   * @param value
   */
  function handleChangeProduct(event: any, value: any) {
    handleChangeProductInParent(event, value);
    setProduct("");
  }
  return (
    <div style={styles ? styles : {}}>
      <Autocomplete
        size="small"
        id="product"
        freeSolo={false}
        disablePortal
        disabled={disabled ? disabled : false}
        getOptionLabel={(option: any) => {
          return option.name
            ? `${option.code} - ${option.name.length > 20
              ? `${option.name.substring(0, 20)}...`
              : option.name
            }`
            : option.code;
        }}
        isOptionEqualToValue={(option, value) => option._id === value._id}
        options={products}
        value={
          (parentProduct ? parentProduct : { _id: "", code: product }) || null
        }
        onChange={(event: any, value: any) => {
          handleChangeProduct(event, value);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            name="product"
            label={Vocabulary.product}
            variant={variant ? variant : "standard"}
            helperText={
              parentProduct && parentProduct.variant
                ? `Culoare produs:  ${parentProduct.variant.option1}`
                : null
            }
            onChange={(event: any) => {
              const value = event.target.value;
              setProduct(value);
              if (value && value.length >= 2) {
                searchProducts(value);
              }
            }}
          />
        )}
      />
    </div>
  );
}
